export const getChatbotFeatureFlag = (state) =>
  state.featureFlags?.featureFlags?.enableChatBot;

export const getFeatureFlagsLoading = (state) =>
  state.featureFlags?.featureFlags?.loading;

export const getFeatureFlags = (state) => state.featureFlags?.featureFlags;
